/**
 * Registry der Karten-Marker-Icons aus public/icons/.
 * Einzige Quelle für diese Pfade — nicht als String-Literal duplizieren.
 */
export const mapIcons = {
  windrad: "/icons/windrad.png",
  windradSw: "/icons/windrad_sw.png",
  windrad2: "/icons/windrad2.svg",
  baum: "/icons/baum.png",
  tanne: "/icons/tanne.png",
  haus: "/icons/haus.png",
  flurstueck: "/icons/flurstueck.png",
  strommast: "/icons/strommast.png",
} as const;
